import { useMsal } from '@azure/msal-react';
import { useState, useEffect } from 'react';
import { AuthHelper } from '../auth/AuthHelper';
import { FileDownloadService } from '../services/FileDownloadService';

export const useFileDownloadService = () => {
    const { instance, inProgress } = useMsal();
    const [fileDownloadService, setFileDownloadService] = useState<FileDownloadService | null>(null);

    useEffect(() => {
        const initializeService = async () => {
            try {
                const accessToken = await AuthHelper.getSKaaSAccessToken(instance, inProgress);

                const service = new FileDownloadService();
                service.setAccessToken(accessToken);
                setFileDownloadService(service);
            } catch (error) {
                console.error('Error initializing FileDownloadService:', error);
            }
        };
        void initializeService();
    }, [instance, inProgress]);

    return fileDownloadService;
};